import { supabase } from '@/lib/supabase'
import type { PlanInterval } from '@/lib/subscriptionPlan'

export type CheckoutFailureReason =
  | 'not_authenticated'
  | 'invoke_failed'
  | 'missing_url'
  | 'unknown'

export type CreateCheckoutSessionResult =
  | { ok: true; url: string }
  | { ok: false; reason: CheckoutFailureReason; error?: unknown }

export async function createCheckoutSession(interval: PlanInterval = 'month'): Promise<CreateCheckoutSessionResult> {
  try {
    const { data: sessionData } = await supabase.auth.getSession()

    if (!sessionData.session) {
      return { ok: false, reason: 'not_authenticated' }
    }

    const { data, error } = await supabase.functions.invoke('create-checkout', {
      headers: {
        Authorization: `Bearer ${sessionData.session.access_token}`,
      },
      body: {
        interval,
      },
    })

    if (error) {
      return { ok: false, reason: 'invoke_failed', error }
    }

    if (!data?.url || typeof data.url !== 'string') {
      return { ok: false, reason: 'missing_url' }
    }

    return { ok: true, url: data.url }
  } catch (error) {
    return { ok: false, reason: 'unknown', error }
  }
}
